export function emailAccountDeletionHTML(toName, fromName, yardName) {
  return `<!-- Begin HTML Content -->
      <h1> ${toName}, <br><br> Your transloads.co account has been deleted. <br></h1>
      <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
      <br><br>
      This is to inform you that ${fromName} at ${yardName} has deleted your account from transloads.co. <br>
      If you believe this is a mistake or have any concerns, please contact your manager as soon as possible.
      <br><br><br>
      <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
      <br>
      If you need assistance or have any further questions, please contact your manager.
      <!-- End HTML Content -->`;
}
